import { render, staticRenderFns } from "./PartnerRegisterBasicInformation.vue?vue&type=template&id=298e6416&"
import script from "./PartnerRegisterBasicInformation.vue?vue&type=script&lang=ts&"
export * from "./PartnerRegisterBasicInformation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports